import { render } from "./NewEndpointFormFields.vue?vue&type=template&id=4520b5fa"
import script from "./NewEndpointFormFields.vue?vue&type=script&lang=js"
export * from "./NewEndpointFormFields.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__